import { Injectable } from '@angular/core';
import { LoggerService } from 'src/app/services/logger.service'
import { Store } from "@ngxs/store";
import { UuidAndId } from '../state-man/models/uuid-and-id';
import { UiService } from './ui.service';
import { StoreActions } from '../state-man/actions/store.actions';
import { User } from '../state-man/models/user.model';
import { SurveyService } from './survey.service';
import { SurveyActions } from '../state-man/actions/survey.actions';
import { Survey } from '../state-man/models/survey.model';
import { ConfigActions } from '../state-man/actions/config.actions';
import { ProjectActions } from '../state-man/actions/project.actions';

@Injectable({
  providedIn: 'root'
})
export class OfflineService {  
  is_processing_surveys = false
  
  constructor(        
    private surveyEntryService: SurveyService,  
    private store: Store,
    private uiService: UiService    
    ) {}

  async processPendingSurveys(surveyEntries: Survey[]) {
    try {
      if (!this.is_processing_surveys) {
        this.is_processing_surveys = true
        await this.uploadPendingSurveyDeletes(surveyEntries)
        await this.uploadPendingSurveySaves(surveyEntries)
        this.is_processing_surveys = false
      }
    } catch(e) {
      LoggerService.log(e)
      this.is_processing_surveys = false
    }
  }
  
  async uploadPendingSurveySaves(surveyEntries: Survey[]) {    
    try {              
        for (const surveyEntry of surveyEntries) {  
          if (surveyEntry.is_pending_save) {
            if (surveyEntry.id <= 0) {
              const apiObj = await this.surveyEntryService.addSurvey(surveyEntry)  
              if (apiObj) {
                const id: number = apiObj.id
                const uuid: string = surveyEntry.uuid
                const payload: Survey = Survey.buildOne({...apiObj, uuid, id})
                this.store.dispatch(new SurveyActions.ApiAddedOne(payload))  
              } 
            } else {
              const apiObj = await this.surveyEntryService.updateSurvey(surveyEntry)  
              if (apiObj) {
                const id: number = apiObj.id
                const uuid: string = surveyEntry.uuid
                const payload: Survey = Survey.buildOne({...apiObj, uuid, id})
                this.store.dispatch(new SurveyActions.ApiUpdatedOne(payload))  
              } 
            }
          }
        }                    
    } catch (error) {            
      LoggerService.log(error)   
      await this.uiService.showToast('An unexpected error occurred and has been sent to the support team.')    
    } 
  }

  async uploadPendingSurveyDeletes(surveyEntries: Survey[]) {    
    try {              
        for (const surveyEntry of surveyEntries) {  
          if (surveyEntry.is_pending_delete) {            
            const status = await this.surveyEntryService.deleteSurvey(surveyEntry)              
            if (status && status === 'OK') {
              const id: number = surveyEntry.id
              const uuid: string = surveyEntry.uuid
              const payload: UuidAndId = {uuid, id}                   
              this.store.dispatch(new SurveyActions.ApiDeletedOne(payload))  
            }             
          }
        }                    
    } catch (error) {            
      LoggerService.log(error)   
      await this.uiService.showToast('An unexpected error occurred and has been sent to the support team.')    
    } 
  }
 
  async refresh(user: User) {
    try {            
      this.store.dispatch(new ConfigActions.Refresh())                
      this.store.dispatch(new StoreActions.Refresh(user))
      this.store.dispatch(new SurveyActions.Refresh())
      this.store.dispatch(new ProjectActions.Refresh())

      // Do this to trigger uploading pending data
      await this.trigger_pending()
      //this.uiService.stopWait()
    } catch (e) {
      //this.uiService.stopWait()
      LoggerService.log(e)
    }  
  }  

  async trigger_pending() {
    try {
      // Do this to trigger uploading pending data
      this.store.dispatch(new SurveyActions.IncrementPendingCount())
    } catch (e) {
      LoggerService.log(e)
    }  
  }  

}
